import { ActionType } from '../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../core/api/rsaa';
import { Endpoints } from '../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../core/api/module';
import * as R from 'ramda';
import { ParticipantProject } from './models';


const KEY_ACTION = ActionType.LoadProjectSummaryRequest;
const ACTIONS    = [
  ActionType.LoadProjectSummaryRequest,
  ActionType.LoadProjectSummaryResponse,
  ActionType.LoadProjectSummaryError,
];


type Payload = ParticipantProject;

type Meta = {
  projectId: number,
  participantId: number,
};


/**
 * Dispatch this action to load a bunch of basic information about a specific project
 */
export const loadProjectSummaryAction = (
  projectId: number,
  participantId: number,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.ProjectSummary,
  headers:  { 'content-type': 'application/json' },
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId, participantId }),
  body:     state => JSON.stringify({
    projectId:     projectId,
    participantId: participantId,
    languageId:    state.locale.lang.languageId,
  }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assoc('projectSummary', payload, successState);
};


export const loadProjectSummaryReducer = makeApiReducer<Payload>(ACTIONS, KEY_ACTION, reducer);
